var _desc, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSatisfaction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Happy Emoji") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A solid styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    d: "M32 2a30 30 0 1 0 30 30A30 30 0 0 0 32 2zm10 19.9a6 6 0 0 1 6 6 2 2 0 1 1-4 0 2 2 0 1 0-4 0 2 2 0 1 1-4 0 6 6 0 0 1 6-6zm-20 0a6 6 0 0 1 6 6 2 2 0 1 1-4 0 2 2 0 1 0-4 0 2 2 0 1 1-4 0 6 6 0 0 1 6-6zm27.7 20a20.5 20.5 0 0 1-35.5-.3 2 2 0 0 1 3.5-2 16.5 16.5 0 0 0 28.5.2 2 2 0 1 1 3.4 2z",
    fill: "#253858"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfaction);
export default __webpack_public_path__ + "static/media/Satisfaction.49c6ac4701cc0f9f9fb885f2e15a1116.svg";
export { ForwardRef as ReactComponent };